"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCommonRequestChannel = void 0;
var base_channel_1 = require("../base-channel/base-channel");
var common_request_params_packer_1 = require("./common-request-params-packer");
var common_response_handler_1 = require("./common-response-handler");
var base_channel_interface_1 = require("../base-channel/base-channel.interface");
var base_1 = require("../../base");
var DefaultPath = '/dop-api/commitchanges';
/**
 * 通用请求通道，响应结果不做处理直接返回
 */
var CommonRequestChannel = /** @class */ (function (_super) {
    __extends(CommonRequestChannel, _super);
    function CommonRequestChannel(options) {
        var _this = _super.call(this, options, {
            requestUrl: DefaultPath,
            method: base_channel_interface_1.Method.POST,
            contentType: base_1.ContentType.JSON,
        }) || this;
        _this.options = options;
        _this.init();
        return _this;
    }
    /**
     * 初始化打包器和响应处理器
     */
    CommonRequestChannel.prototype.init = function () {
        this.paramsPacker = new common_request_params_packer_1.CommonRequestParamsPacker();
        this.responseHandler = new common_response_handler_1.CommonResponseHandler();
    };
    return CommonRequestChannel;
}(base_channel_1.BaseChannel));
/**
 * 创建通道实例
 * @param options
 */
function buildCommonRequestChannel(options) {
    return new CommonRequestChannel(options);
}
exports.buildCommonRequestChannel = buildCommonRequestChannel;
